import type { FC } from 'react';
import React from 'react';

import { cn } from '@wwe-portal/ui/lib/lib';

export type WebCoinIconProps = React.ReactComponentElement<'svg'>['props'];
export const WebCoinIcon: FC<WebCoinIconProps> = (props) => {
  return (
    <svg
      fill="none"
      height="18"
      viewBox="0 0 18 18"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={cn('size-[13px]', props.className)}
    >
      <path
        clipRule="evenodd"
        d="M8.99867 17.3308C13.6007 17.3308 17.3313 13.6002 17.3313 8.99818C17.3313 4.39618 13.6007 0.665527 8.99867 0.665527C4.39667 0.665527 0.666016 4.39618 0.666016 8.99818C0.666016 13.6002 4.39667 17.3308 8.99867 17.3308ZM9.95446 12.4695H11.3585L13.53 5.93892H11.7504L10.632 9.28586L9.67691 5.93892H8.31365L7.35855 9.28586L6.2565 5.93892H4.46875L6.64018 12.4695H8.05242L9.00752 9.31035L9.95446 12.4695Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};
